export enum MTDReport { Store, Employee, Compare}
